import { render, staticRenderFns } from "./AttachIcon.vue?vue&type=template&id=7d2e0ee8&"
import script from "./AttachIcon.vue?vue&type=script&lang=js&"
export * from "./AttachIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports